// Footer Component

import styles from './Footer.module.css';

export function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className={styles.footer}>
      <div className={styles.container}>
        <p className={styles.copyright}>
          &copy; {currentYear} ChemMasters, Inc. All rights reserved.
        </p>
        <p className={styles.address}>
          300 Edwards Street, Madison, Ohio 44057 | Phone: 440.428.2105
        </p>
      </div>
    </footer>
  );
}
